import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { BurrowNav } from '../components/BurrowNav'
import { errorText, Loading, Notice } from '../components/ui'
import { useBackend } from '../lib/session'
import type { Writing } from '../lib/types'
import { Composer } from './composer/Composer'

// /w/:id — load the writing, then hand it to the Composer (pages/composer/*).

export function ComposerPage() {
  const { id = '' } = useParams()
  const backend = useBackend()
  const [writing, setWriting] = useState<Writing | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let alive = true
    backend
      .getWriting(id)
      .then((w) => {
        if (!alive) return
        if (w) setWriting(w)
        else setError('This writing doesn’t exist, or it isn’t yours.')
      })
      .catch((e: unknown) => alive && setError(errorText(e)))
    return () => {
      alive = false
    }
  }, [backend, id])

  if (error) {
    return (
      <div className="min-h-dvh bg-canvas">
        <BurrowNav />
        <Notice title="Couldn’t open this writing" body={error} />
      </div>
    )
  }
  if (!writing) {
    return (
      <div className="min-h-dvh bg-canvas">
        <BurrowNav />
        <Loading label="Opening your writing…" />
      </div>
    )
  }
  return <Composer key={writing.id} initial={writing} />
}
